import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { closeRewardsGrid, showRoulette } from '../../actions/actions';
import Thumbnail from '../thumbnail';
import './style.scss';

export class RewardGrid extends React.Component {
  closeRewardGrid() {
    this.props.closeRewardsGrid();
  }

  getSelectedTotal() {
    return this.props.rewards.filter((reward) => {return reward.selected;}).length;
  }

  getTitle() {
    switch(this.getSelectedTotal()) {
      case 0:
        return "Choose 3 rewards and give it a spin!";
      case 1:
        return "Two more to go...";
      case 2:
        return "One more... come on :)";
      case 3:
        return "Well done!";
    }
  }

  isMaximumSelectedReached() {
    return this.getSelectedTotal() >= this.props.roulette.amountOfRewardsAllowedToSelect;
  }

  showRoulette() {
    this.props.showRoulette();
    this.props.closeRewardsGrid();
  }

  render() {
    let gridClassNames = classNames(
      'grid',
      { 'selected-maximum-is-reached': this.isMaximumSelectedReached() }
    );

    let buttonClassNames = classNames(
      'btn',
      { 'disabled': !this.isMaximumSelectedReached() }
    );

    return (
      <div className="whiteout">
        <div className="flexModal">
          <div className="flexModal__inner">
            <div className="flexModal__header">
              <h1>{this.getTitle()}</h1>
              <button className="btn-icon" onClick={this.closeRewardGrid.bind(this)}><span className="icon-cross"/></button>
            </div>
            <div className="flexModal__body">
              <div className={gridClassNames}>
              {
               this.props.rewards.map(
                  (reward, index) => {return (
                    <div key={index} className="grid-item">
                      <Thumbnail id={reward.id} image={reward.image} title={reward.title} selected={reward.selected} />
                    </div>
                  );}
                )
              }
              </div>
            </div>
            <div className="flexModal__footer">
              <button className={buttonClassNames} onClick={this.showRoulette.bind(this)}>Let's do this!</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RewardGrid.propTypes = {
  closeRewardsGrid: React.PropTypes.func,
  showRoulette: React.PropTypes.func,
  roulette: React.PropTypes.object,
  rewards: React.PropTypes.array
};

const mapStateToProps = (state) => ({
  rewards: state.rewards,
  roulette: state.roulette
});

export default connect(mapStateToProps, { closeRewardsGrid, showRoulette })(RewardGrid);



/** WEBPACK FOOTER **
 ** ./src/components/rewardGrid/index.js
 **/